import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './index.css';
import reportWebVitals from './reportWebVitals';
import { router } from './router/Routes';
import { store, StoreContext } from './stores/store';
import * as  serviceWorkerRegistration from './serviceWorkerRegistration';
import "./data/translations/i18n";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <StoreContext.Provider value={store}>
        <RouterProvider router={router} />
    </StoreContext.Provider>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
